module.exports = "/_next/static/images/banner_icon_toybaton-5f69daf6c991600db6dbc89741a7e071.svg";